var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":""}},[(_vm.showReworksBlock())?_c('modules-rework-student-wrapper',{key:_vm.$route.fullPath}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }